export const translateStatus = (location) => {
  // an address can have no status row for the project of this row (nothing
  // started there yet); the backend returns status: null for it
  const status = location.status?.overall?.status
  switch (status) {
    // the project's first task exists but nothing has progressed yet
    case 'created':
      return 'aangemaakt'
    case 'finished':
      return 'afgerond'
    case 'design':
      return 'ontwerp'
    case 'sales':
      return 'werving'
    case 'inspection':
      return 'schouw'
    case 'installation':
      return 'installatie'
    case 'cancelled': {
      const { inspection, sales, design, installation } = location.status || {}

      if (inspection?.status === 'cancelled') {
        return 'schouw geannuleerd'
      } else if (sales?.status === 'cancelled') {
        return 'werving geannuleerd'
      } else if (design?.status === 'cancelled') {
        return 'ontwerp geannuleerd'
      } else if (installation?.status === 'cancelled') {
        return 'installatie geannuleerd'
      } else {
        return 'geannuleerd'
      }
    }
    default:
      return 'geen status'
  }
}
